<template>
    <div v-if="visible" :class="containerClass">
        <div class="migrol-form__login-message">
            <div class="migrol-form__login-message-title">{{Strings['Global.LoginInfo.Title']}}</div>
            <v-runtime-template :template="content" />
        </div>
    </div>
</template>

<script>
    import VRuntimeTemplate from "v-runtime-template";

    export default {
        props: {
            containerClass: {
                type: String,
                default: null,
                required: false
            }
        },
        computed: {
            Strings() {
                return this.$migrolVueLibraryData.Strings;
            },
            Settings() {
                return this.$migrolVueLibraryData.Settings;
            },
            content() {
                return this.Strings['Global.LoginInfo.Text'];
            },
            visible() {
                return this.$migrolVueLibraryData.SettingsLoaded && this.Settings['isLoggedIn'] != true;
            },
            href() {
                return '/auth/login?returnUrl=' + encodeURIComponent(window.location.href);
            }
        },
        components: {
            VRuntimeTemplate
        }
    };
</script>